import React from "react";
import { Button, Avatar, Box, Typography, Alert } from "@mui/material";
import { CloudUpload as CloudUploadIcon, Person as PersonIcon } from "@mui/icons-material";

const PhotoUpload = ({ imageFile, handleImageChange, imageError }) => {
  // Create a preview URL if imageFile exists
  const previewUrl = imageFile ? URL.createObjectURL(imageFile) : undefined;

  return (
    <Box sx={{ mb: 4, textAlign: "center" }}>
      <Typography variant="body2" sx={{ color: "gray", mb: 1 }}>
        Le fichier doit être une image jpg/png/jpeg et ne doit pas dépasser 5 Mo.
      </Typography>

      {/* Avatar with custom background color */}
      <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
        <Avatar
          sx={{
            width: 100,
            height: 100,
            backgroundColor: previewUrl ? "transparent" : "#2F4E8B  ",
          }}
          src={previewUrl}
        >
          {!imageFile && <PersonIcon sx={{ fontSize: 48, color: "#fff" }} />}
        </Avatar>
      </Box>

      {/* File input button remains unchanged */}
      <Button
        variant="contained"
        component="label"
        startIcon={<CloudUploadIcon />}
        sx={{
          width: "50%",
          backgroundColor: "#2F4E8B  ",
          "&:hover": { backgroundColor: "#2F4E8B  " },
          padding: 1.5,
          mb: 2,
          display: "inline-flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography
          variant="body2"
          fontWeight="bold"
          sx={{ fontSize: "0.875rem", textAlign: "center" }}
        >
          Télécharger Photo
        </Typography>
        <input type="file" hidden accept="image/*" onChange={handleImageChange} />
      </Button>

      {imageError && (
        <Alert severity="error" sx={{ mb: 2 }}>
          {imageError}
        </Alert>
      )}
    </Box>
  );
};

export default PhotoUpload;
